export default __webpack_public_path__ + "static/gurumurthy-sithuraj-5df9858e844bde81f48a264f2dde96b5.png";